import React, {useEffect, useState} from "react";
import "./App.less";
import {Layout} from "./layout/Layout";
import {queryClient} from "./config/queryClient";
import browserHistory from "./config/browserHistory";
import {QueryClientProvider} from "react-query";
import { ReactQueryDevtools } from 'react-query/devtools'
// Check https://github.com/remix-run/react-router/pull/7586
import {unstable_HistoryRouter as HistoryRouter} from "react-router-dom";
import {ErrorBoundary} from "@sentry/react";
import {ServerErrorPage} from "./pages/ServerErrorPage";
import {OrganisationInformationProvider} from "./layout/OrganisationInformationProvider";
import keycloak, { KeycloakInitTokens } from "./config/keycloak";
import { KeycloakInitOptions } from "keycloak-js";
import { extractDashboardSubdomain, isSupportedSubdomain } from "./utils";
import {UnsupportedSubdomainPage} from "./pages/UnsupportedSubdomainPage";

function App() {
    const [authChecked, setAuthChecked] = useState<boolean>(false);
    const origin = window.location.origin;
    const subdomain = extractDashboardSubdomain(origin);
    const subdomainSupported = subdomain && isSupportedSubdomain(subdomain);

    useEffect(() => {
        if (subdomain && !subdomainSupported) {
            return;
        }

        const tokens = localStorage.getItem('tokens');
        let kcInitOptions: KeycloakInitOptions = {
            onLoad: 'check-sso',
            checkLoginIframe: false
        }; 

        if (tokens) {
            console.log("Initialised with tokens");
            const parsedTokens = JSON.parse(tokens) as KeycloakInitTokens;
            kcInitOptions = {
                ...kcInitOptions,
                ...parsedTokens,
            }
        }

        keycloak
            .init(kcInitOptions)
            .then((authenticated) => {
            if (!authenticated) {
                const idpHint = subdomain;
                console.log("User not authenticated, forcing login", { idpHint });
                keycloak.login({ 
                    idpHint,
                    redirectUri: window.location.origin,
                });
            } else {
                setAuthChecked(true);
            }
        }).catch((error) => {
            console.error("Keycloak init failed", error);
        });
    }, [subdomain, subdomainSupported]);

    if (subdomain && !subdomainSupported) {
        return <UnsupportedSubdomainPage origin={origin} subdomain={subdomain}/>;
    }

    if (!authChecked) {
        return null;
    }

    return (
        <QueryClientProvider client={queryClient}>
            <HistoryRouter history={browserHistory}>
                <ErrorBoundary fallback={(props) => <ServerErrorPage {...props}/>}>
                    <OrganisationInformationProvider>
                        <Layout/>
                    </OrganisationInformationProvider>
                </ErrorBoundary>
            </HistoryRouter>
            <ReactQueryDevtools initialIsOpen={false} position='bottom-right'/>
        </QueryClientProvider>
    );
}

export default App;
